var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49833 0.855608C2.65904 0.855608 0.355469 3.15918 0.355469 5.99847C0.355469 8.83775 2.65904 11.1413 5.49833 11.1413C8.33761 11.1413 10.6412 8.83775 10.6412 5.99847C10.6412 3.15918 8.33761 0.855608 5.49833 0.855608ZM6.35547 9.20605C6.35547 9.32659 6.26172 9.42704 6.14788 9.42704H4.86217C4.74163 9.42704 4.64118 9.32659 4.64118 9.20605V7.93373C4.64118 7.8132 4.74163 7.71275 4.86217 7.71275H6.14788C6.26172 7.71275 6.35547 7.8132 6.35547 7.93373V9.20605ZM6.34208 6.90248C6.33538 6.99623 6.23493 7.06989 6.1144 7.06989H4.87556C4.74833 7.06989 4.64788 6.99623 4.64788 6.90248L4.53404 2.744C4.53404 2.69713 4.55413 2.65025 4.601 2.62347C4.64118 2.58998 4.70145 2.56989 4.76172 2.56989H6.23493C6.2952 2.56989 6.35547 2.58998 6.39565 2.62347C6.44252 2.65025 6.46261 2.69713 6.46261 2.744L6.34208 6.90248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.ea4a77ca2d82cb80871b5d35c61ec956.svg";
export { ForwardRef as ReactComponent };